<div [class.show]="isOpened"></div>
<div class="popover">
  <ng-content></ng-content>
</div>

